import React from "react";
import { ScrollView, StyleSheet } from "react-native";

import UserProfileCard from "./UserProfileCard";

import { type UserProfile } from "@/schemas/user/profile";
import {
  GREATK_USER_PROFILE,
  OBIY_USER_PROFILE,
  TN531_USER_PROFILE,
} from "@/schemas/profile/__mocks__/UserProfile";

export function PeopleBar(): React.JSX.Element {
  const users: UserProfile[] = [
    TN531_USER_PROFILE,
    GREATK_USER_PROFILE,
    OBIY_USER_PROFILE,
  ];

  const styles = StyleSheet.create({
    scrollView: {
      maxWidth: "20%",
    },
  });

  return (
    <ScrollView style={styles.scrollView}>
      {users.map((user) => (
        <UserProfileCard key={user.username} profile={user} />
      ))}
    </ScrollView>
  );
}
export default PeopleBar;
